import React, { useRef, useEffect } from "react";
import css from "./services.module.css";

const ServiceCard = ({ service, index }) => {
  const revealRef = useRef(null);

  useEffect(() => {
    const revealEl = revealRef.current;
    if (!revealEl) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    observer.observe(revealEl);
    return () => observer.disconnect();
  }, []);

  const delayClass = `reveal-delay-${Math.min(index + 1, 5)}`;

  return (
    <div ref={revealRef} className={`reveal ${delayClass}`}>
      <div className={css.card}>
        <span className={css.number}>{service.number}</span>
        <h3 className={css.title}>{service.title}</h3>
        <p className={css.text}>{service.text}</p>
        <div className={css.tags}>
          {service.tags.map((tag, i) => (
            <span key={i} className={css.tag}>{tag}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
